import React, { useEffect, useState } from 'react'
import './AlbaranModal.scss'
import { pdfjs } from 'react-pdf';
import { Box, Button, CircularProgress, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'
import { digitalAppApi } from '../../../../store/services/digitalAppApi';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const AlbaranModal = ({
  open,
  onClose,
  selectedOrder = null,
}) => {
  // console.log(selectedOrders[0][0]?._id)
  // Для одного заказа - упрощенная логика

  const order = selectedOrder

  const { 
    data: albaranData, 
    isLoading: isLoadingAlbaran, 
    isError: isErrorAlbaran,
    isSuccess
  } = digitalAppApi.useGetAlbaranByIdQuery({id: order}, { 
    skip: !(open && order), // Пропускаем запрос, если модалка закрыта или нет ID
  });

  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  
  useEffect(() => {
    let urlToRevoke = null;

    // 💡 ПРОВЕРКА: Проверяем, что запрос успешен (isSuccess) 
    // и что данные являются Blob (albaranData instanceof Blob)
    if (isSuccess && albaranData instanceof Blob) {
      urlToRevoke = URL.createObjectURL(albaranData);
      setPdfBlobUrl(urlToRevoke);
    } else {
      setPdfBlobUrl(null);
    }

    // Очистка
    return () => {
      if (urlToRevoke) {
        URL.revokeObjectURL(urlToRevoke);
      }
    };
  }, [albaranData, isSuccess]);

  // console.log("PDF Data:", albaranData);
  // console.log("Is Success:", isSuccess);
  // console.log("Is Blob:", albaranData instanceof Blob); 
  // console.log("PDF URL:", pdfBlobUrl);

  const handleDownloadServerPdf = () => {
    if (pdfBlobUrl) {
      const link = document.createElement('a');
      link.href = pdfBlobUrl;
      link.download = `albaran_${order}_server.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleOpenServerPdf = () => {
    if (pdfBlobUrl) {
      window.open(pdfBlobUrl, '_blank');
    }
  };

  if (!order) return null
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='albaran-modal-title'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: isViewerOpen ? '90%' : 500 },
          height: isViewerOpen ? '90%' : 'auto',
          maxHeight: '90%',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
        }}
      >
        <Box 
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
        >
          <Typography
            id='albaran-modal-title'
            variant='h6'
            component='h2'
            gutterBottom
          >
            Print Albaran
          </Typography>
          <IconButton
            onClick={onClose}
            className='driver-comments-modal__close'
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant='body2' color='text.secondary'>
            Order ID: {order?.slice(-6) || 'N/A'}
          </Typography>
          
          <Typography 
            variant='body2' 
            color={
              isLoadingAlbaran ? 'warning.main' : 
              isErrorAlbaran ? 'error.main' : 
              pdfBlobUrl ? 'success.main' : 'text.secondary'
            }
          >
            PDF Status: 
            {isLoadingAlbaran ? (
              <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress color='warning' size={14} /> Loading...
              </Box>
            ) : isErrorAlbaran ? 'Error fetching PDF' : pdfBlobUrl ? 'Ready' : 'Waiting for data'}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center', mt: 2 }}>
          
          {pdfBlobUrl && !isLoadingAlbaran && (
            <>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                  variant='outlined'
                  onClick={handleDownloadServerPdf}
                  sx={{ minWidth: 120 }}
                >
                  Download PDF
                </Button>
                <Button
                  variant='outlined'
                  onClick={handleOpenServerPdf}
                  sx={{ minWidth: 120 }}
                >
                  Open in New Tab
                </Button>
              </Box>
            </>
          )}

          {isErrorAlbaran && (
            <Typography color='error'>
              Error: Failed to fetch document. 
              {albaranData?.error?.message}
            </Typography>
          )}
        </Box>
        {pdfBlobUrl && !isLoadingAlbaran && (
          <Box 
            sx={{ 
              height: { xs: '60dvh', sm: '70dvh' }, 
              width: '100%', 
              mt: 2, 
              border: '1px solid #ccc' 
            }}
          >
            <iframe
              src={pdfBlobUrl} // Используем URL, полученный из серверного Blob
              title="Server Albaran PDF Viewer"
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            />
          </Box>
        )}

        {/* Скрытые поля - данные заполняются автоматически */}
        <Box sx={{ display: 'none' }}>
          
        </Box>
      </Box>
    </Modal>
  )
}

export default React.memo(AlbaranModal)